import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { RequestError } from '@/app/common/types_and_interfaces.ts'
import {
  runPreviewDistribution,
  type RunPreviewDistributionParams,
} from './requests'
import { type RunPreviewDistributionResponse } from './schemas.ts'

export const useRunPreviewDistribution = (
  options?: UseMutationOptions<
    RunPreviewDistributionResponse,
    RequestError,
    RunPreviewDistributionParams
  >
) => {
  return useMutation({
    mutationFn: runPreviewDistribution,
    onSuccess: options?.onSuccess,
    onError: options?.onError,
    onSettled: options?.onSettled,
  })
}
